export default __webpack_public_path__ + "static/media/Catamaran-Regular.f3f54355.ttf";